import React from "react";
import "./TransmitContainer.css";

export default function TransmitContainer(props) {
  return <div id="transmitContainer"></div>;
}
